if (!customElements.get("supplements-bar")) {
  class SupplementsBar extends HTMLElement {
    static POSITION_FIXED_CLASS = "is-fixed";

    constructor() {
      super();
    }

    handleWrapping() {
      const containerRect = this.firstElementChild.getBoundingClientRect();
      const containerWidth = containerRect.width;

      document.documentElement.style.setProperty('--supplements-bar-height', containerRect.height + 'px');

      let totalChildWidth = 0;

      Array.from(this.firstElementChild.children).forEach((child) => {
        totalChildWidth += child.getBoundingClientRect().width;
      });

      if (totalChildWidth < containerWidth) {
        this.style.setProperty("--justify-content", "center");
      } else {
        this.style.setProperty("--justify-content", "flex-start");
      }

      if(this.classList.contains('is-fixed')) return;

      this.style.setProperty('--static-height', this.getBoundingClientRect().height + 'px');
    }

    initObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          const boundingRect = entry.boundingClientRect;
          const viewportHeight =
            window.innerHeight || document.documentElement.clientHeight;

          this.classList.toggle(
            SupplementsBar.POSITION_FIXED_CLASS,
            boundingRect.bottom <= viewportHeight && boundingRect.top < 0
          );

          this.handleWrapping();
        },
        {
          threshold: [0, 1], // Observe at 0% and 100% visibility
          rootMargin: "0px 0px -1px 0px", // Slightly adjust the bottom margin
        }
      );

      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer.disconnect();
      this.observer = null;
    }

    connectedCallback() {
      this.initObserver();

      window.addEventListener("resize", this.handleWrapping.bind(this), {
        passive: true,
      });
    }
  }

  customElements.define("supplements-bar", SupplementsBar);
}
